import React from "react";
import {WarningSignIcon} from "evergreen-ui";

type Props = {
    children: React.ReactNode;
};

export function InlineWarningPanel({children}: Props) {
    return (
        <div
            className="flex items-start p-4 rounded border"
            style={{backgroundColor: "#FDF6EC", borderColor: "#F2C98A"}}
        >
            <div
                className="flex-shrink-0 flex items-center justify-center rounded-full mr-3"
                style={{backgroundColor: "#D9822B", width: 22, height: 22, marginTop: 2}}
            >
                <WarningSignIcon color="white" size={12}/>
            </div>
            <div className="text-sm text-gray-800 flex-1 leading-relaxed">
                {children}
            </div>
        </div>
    );
}
